import { CompaniesAppBaseDataProvider } from './CompaniesAppBaseDataProvider';
import { CompanyTypeData } from '../../../company/types/company-type-data';
import { sanitizeArray } from '../../../utils/sanitization.utils';

export class CompaniesAppGzDataProvider extends CompaniesAppBaseDataProvider {
  public async getCompanyTypes(): Promise<CompanyTypeData[]> {
    const data = await this.dependencies.api.clients.Company.GetCompanyTypes().toPromise();
    return sanitizeArray(data);
  }

  public async getNumberOfCompaniesInContainer(companyIds: Array<{ _id: string }>): Promise<number> {
    return await this.dependencies.api.clients.Companies.GetNumberOfCompaniesInContainer(companyIds).toPromise();
  }

  public async removeCompanyRecords(companyIds: Array<{ _id: string }>): Promise<object> {
    return await this.dependencies.api.clients.Companies.RemoveCompanyRecords(companyIds).toPromise();
  }
}
